

exports.__esModule = true;
exports.$PayRoute = undefined;

var _angular = require('angular');

var _integration = require('js/lib/integration');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

var _inventory = require('xo-models/src/inventory');

var _profilemanagement = require('xo-models/src/profilemanagement');

var _shoppingcart = require('xo-models/src/shoppingcart');

/**
 * PayRoute
 * - Responsible for making the payment call and handling contingencies if any.
 */

var $PayRoute = exports.$PayRoute = _squid.$ComponentRoute.extend('PayRoute', {

    path: 'pay',

    trackingData: {
        fptiState: 'make_payment',
        trackStateExit: true
    },

    resolve: {
        action: function action() {

            var token = _angular.$rootScope.token;
            var models = {};

            var getMerchantPreferences = function getMerchantPreferences() {
                return (0, _squid.$populate)(models, {
                    pref: _profilemanagement.$MerchantPreferenceModel.instance(models.payee.merchant.id)
                });
            };

            var markCartCheckedout = function markCartCheckedout() {

                var enabled = _squid.$config.enableShoppingCartWPS && models.checkoutAppData.flags.is_shopping_cart_flow;

                if (!enabled) {
                    return _angular.$q.when();
                }

                var shoppingCartModel = _shoppingcart.$ShoppingCartModel.instance(token);

                return shoppingCartModel.action('cartCheckedOut', {
                    data: {
                        payee_email: models.checkoutAppData.get('merchant.merchant_email')
                    },
                    success: function success(result) {
                        _logger.$logger.info('CART_CHECKED_OUT');
                    }
                });
            };

            var manageInventory = function manageInventory(paymentStatus) {
                var cartHasInventory = models.checkoutCart.get('cartHasInventory');

                if (!cartHasInventory) {
                    return _angular.$q.when();
                }

                var inventoryModel = _inventory.$InventoryModel.instance(token);

                var inventoryItems = inventoryModel.getInventoryItems();

                paymentStatus = paymentStatus ? paymentStatus : 'success';

                var inventoryPatchInput = {
                    inventoryItems: inventoryItems,
                    cartItems: models.checkoutCart.get('purchaseUnits')[0].item_list.items,
                    merchantId: models.payee.get('merchant.id', ''),
                    paymentStatus: paymentStatus
                };

                return inventoryModel.action('patchInventory', {
                    data: inventoryPatchInput,
                    success: function success(patchResponse) {
                        if (patchResponse && patchResponse.showSoldoutPage) {
                            // show soldout page
                            return _angular.$q.when({
                                soldoutpage: true,
                                items: encodeURIComponent(patchResponse.soldoutItems),
                                soldoutUrl: encodeURIComponent(patchResponse.soldoutUrl)
                            });
                        } else if (patchResponse && patchResponse.patchCart) {
                            // patch cart with updated inventory
                            var purchase_unit = models.checkoutCart.get('purchaseUnits')[0];

                            purchase_unit.item_list.items = patchResponse.cartItems;

                            var patchCartPayload = {
                                id: token,
                                patchEntities: [{
                                    field: 'inventoryItems',
                                    value: purchase_unit.item_list.items
                                }]
                            };

                            return models.checkoutCart.action('patchCartData', {
                                data: patchCartPayload
                            });
                        }
                        return _angular.$q.when();
                    }
                });
            };

            var showSoldOutPage = function showSoldOutPage(soldOutData) {
                return _angular.$q.when({
                    to: 'checkout.soldout',
                    params: {
                        items: soldOutData.items,
                        soldOutUrl: soldOutData.soldoutUrl
                    }
                });
            };

            var showGenericError = function showGenericError(code) {
                return function () {
                    var encoded = code ? window.btoa(code) : code;

                    manageInventory('failed');
                    return _uiRouter.$state.go('checkout.genericError', { code: encoded });
                };
            };

            var makePayment = function makePayment() {

                var xclickParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);

                return models.checkoutSession.action('createPayment', {
                    data: {
                        payer_id: models.checkoutSession.payer.id,
                        intent: models.checkoutCart.payment_action,
                        wa_type: xclickParams && xclickParams.wa_type,
                        correlation_id: _squid.$meta.correlationId,
                        merchant_id: models.payee.get('merchant.id'),
                        custom: models.checkoutCart.get('purchase.custom'),
                        invoice: models.checkoutCart.get('purchase.invoice')
                    },

                    success: function success(result) {
                        // flag used in other directives
                        _angular.$rootScope.paymentComplete = true;
                        // fire and forget
                        markCartCheckedout();
                        return 'success';
                    },

                    contingencies: {
                        TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                        PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                        DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE'),
                        DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
                        // for cc_processor_declined / default , we can redirect back to review for a retry
                        CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED() {
                            manageInventory('failed');

                            // call createCheckout again and throw processor decline error which will be handled in
                            // xo-review
                            return models.checkoutSession.action('create', {
                                success: function success(result) {
                                    return _angular.$q.reject('CC_PROCESSOR_DECLINED');
                                }
                            });
                        },
                        DEFAULT: function DEFAULT(name, err) {
                            manageInventory('failed');
                            throw err;
                        }
                    }
                });
            };

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(token),
                checkoutCart: _index.$CheckoutCartModel.instance(token),
                checkoutSession: _index.$CheckoutSessionModel.instance(token),
                payee: _index.$CheckoutPayeeModel.instance(token)
            }).then(function () {
                // Check if inventory is available
                return manageInventory();
            }).then(function (inventoryStatus) {
                // Show Sold Out Page if inventory unavailable
                if (inventoryStatus && inventoryStatus.soldoutpage) {
                    return showSoldOutPage(inventoryStatus);
                }
                // Make Payment
                return _angular.$q.all([getMerchantPreferences(), makePayment() // Load the preferences here so its cached for later use in the done page
                ]).then(function () {
                    if (_angular.$rootScope.paymentComplete) {
                        if (_integration.$integration.getConfig('DONE_PAGE')) {
                            // Show Done Page [ Payment Confirmation ]
                            return 'checkout.done';
                        }
                        // default end state
                        return 'checkout.end';
                    }
                })['catch'](function (error) {
                    _logger.$logger.info('XO_PAY_ERROR', { error: error });
                    return 'checkout.review';
                });
            });
        }
    }
});

angular.value("$PayRoute", $PayRoute);
_angular.$q;

_angular.$rootScope;

_integration.$integration;

_uiRouter.$state;

_squid.$ComponentRoute;

_squid.$config;

_squid.$meta;

_squid.$populate;

_squid.$util;

_logger.$logger;

_index.$CheckoutAppDataModel;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_inventory.$InventoryModel;

_profilemanagement.$MerchantPreferenceModel;

_shoppingcart.$ShoppingCartModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pay/route.js
// module id = ./pages/xo-pay/route.js
// module chunks = 0